import { useEffect } from 'react'
import { Modal, ModalBody, ModalOverlay, ModalContent, VStack, ModalHeader } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { isEmpty } from 'lodash'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import colors from 'theme/colors.theme'
import { handleError } from 'API'
import Icon from 'components/Icon'
import Spinner from 'components/Spinner'
import { ICommonLibrary } from 'interfaces/commonLibrary'
import { INotificationWithRelations } from 'interfaces/notification'
import { IProcessWithRelations } from 'interfaces/process'
import { IStepWithRelations } from 'interfaces/step'
import IconBuilder from 'pages/IconBuilderPage/components/IconBuilder'
import routes from 'routes'
import { getValidArray } from 'utils/common'
import styles from './userQuickInfoModal.module.scss'

interface ICommonStepDetailModalProps {
  toggle: () => void
  isOpen: boolean
  selectedCommonStep?: ICommonLibrary
  notification?: INotificationWithRelations
}

const CommonStepDetailModal = (props: ICommonStepDetailModalProps) => {
  const { toggle, isOpen, selectedCommonStep, notification } = props
  const { commonLibraryStore } = useStores()
  const navigate = useNavigate()
  const { currentCommonStepDetail } = commonLibraryStore

  async function fetchCommonStepDetail() {
    try {
      if (notification?.stepId) {
        await commonLibraryStore.fetchCurrentCommonStepDetail(notification.stepId, true)
      } else if (selectedCommonStep) {
        await commonLibraryStore.fetchCurrentCommonStepDetail(selectedCommonStep?.stepId, true)
      }
    } catch (error: any) {
      toggle()
      toast.error('Something went wrong')
      handleError(
        error as Error,
        'components/Pages/CommonLibraryPage/components/CommonStepDetailModal',
        'fetchCommonStepDetail'
      )
    }
  }

  useEffect(() => {
    if (isOpen) {
      fetchCommonStepDetail()
    } else {
      delete commonLibraryStore.currentCommonStepDetail
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} onClose={toggle} size="3xl">
      <ModalOverlay />
      <ModalContent borderRadius={8} marginTop={0} containerProps={{ alignItems: 'center' }}>
        <ModalHeader padding="16px 0px" marginBottom="8px" borderBottom="1px solid #E2E8F0">
          <div className={styles.overviewHeader}>
            <div className={styles.nameWrapper}>Drill list</div>
            <button onClick={toggle} aria-label="Close" title="Close">
              <Icon icon="multiply" group="unicon" />
            </button>
          </div>
        </ModalHeader>

        <ModalBody className={styles.modalWrapper}>
          {commonLibraryStore?.isLoading ? (
            <Spinner />
          ) : (
            <div>
              <VStack alignItems="flex-start">
                <div className={styles.title}>
                  <b>{`${currentCommonStepDetail?.name ?? ''}`}</b>
                  {isEmpty(currentCommonStepDetail?.dependentProcesses)
                    ? ' is not currently reused in any drill.'
                    : ' is reused by these drills below.'}
                </div>
                <VStack
                  background={colors.gray[50]}
                  marginTop="16px"
                  padding="8px"
                  alignItems="flex-start"
                  width="100%"
                >
                  {getValidArray(currentCommonStepDetail?.dependentProcesses).map(process => {
                    return (
                      <div className={styles.processContainer}>
                        <div
                          onClick={() => navigate(`${routes.processes.processId.value(`${process?.id}`)}`)}
                          className={styles.processName}
                        >
                          {process?.name ?? ''}
                        </div>
                      </div>
                    )
                  })}
                </VStack>
              </VStack>
            </div>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default observer(CommonStepDetailModal)
